import { Button } from "@/components/ui/button";
import { ArrowRight, Mail, Phone, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import qcardLogoFooter from "@/assets/qcard-enterprise-logo.png";

const FooterV2 = () => {
  return (
    <>
      {/* Sticky CTA Bar */}
      <div className="fixed bottom-0 left-0 right-0 z-50 bg-slate-900/95 backdrop-blur-lg border-t border-white/10 py-4 md:hidden">
        <div className="container mx-auto px-4">
          <Button className="w-full bg-primary hover:bg-primary/90 text-primary-foreground py-6 font-semibold shadow-lg shadow-primary/30">
            Get Your Free QCard
            <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
        </div>
      </div>

      <footer className="bg-slate-950 text-white pb-24 md:pb-0">
        {/* Final CTA Section */}
        <div className="border-b border-white/10">
          <div className="container mx-auto px-4 py-20">
            <div className="max-w-3xl mx-auto text-center">
              <h2 className="text-3xl md:text-5xl font-bold mb-6">
                Stop Being{" "}
                <span className="text-white/40">Forgotten.</span>
                <br />
                Start Being{" "}
                <span className="text-primary">Saved.</span>
              </h2>
              <p className="text-white/50 text-lg mb-8 max-w-xl mx-auto">
                Join the professionals who refuse to let great connections slip away. Your QCard is free, forever.
              </p>
              <Button size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground text-lg px-12 py-7 font-semibold shadow-lg shadow-primary/30 hover:shadow-xl hover:shadow-primary/40 transition-all" asChild>
                <Link to="/homepage-enterprise" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                  Get Your Free QCard — And Never Be Forgotten Again
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>
              <p className="mt-4 text-sm text-white/30">
                No credit card required. Set up in 60 seconds.
              </p>
            </div>
          </div>
        </div>

        {/* Main Footer */}
        <div className="container mx-auto px-4 py-12">
          <div className="grid md:grid-cols-4 gap-8 lg:gap-12">
            {/* Brand */}
            <div className="md:col-span-1">
              <div className="flex items-center gap-2 mb-4">
                <img src={qcardLogoFooter} alt="QCard Logo" className="h-10 w-auto" />
              </div>
              <p className="text-white/40 text-sm mb-4">
                The digital business card that makes sure you're never forgotten.
              </p>
              <div className="flex gap-4">
                {['Twitter', 'LinkedIn', 'Instagram'].map((social) => (
                  <a
                    key={social}
                    href="#"
                    className="w-10 h-10 rounded-full bg-white/5 hover:bg-primary/20 flex items-center justify-center transition-colors border border-white/10"
                  >
                    <span className="text-xs text-white/60">{social[0]}</span>
                  </a>
                ))}
              </div>
            </div>

            {/* Links */}
            <div>
              <h4 className="font-semibold mb-4 text-white">Product</h4>
              <ul className="space-y-3 text-white/40">
                <li><a href="#" className="hover:text-primary transition-colors">Features</a></li>
                <li><a href="#" className="hover:text-primary transition-colors">Pricing</a></li>
                <li><a href="#" className="hover:text-primary transition-colors">For Teams</a></li>
                <li><a href="#" className="hover:text-primary transition-colors">NFC Cards</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold mb-4 text-white">Company</h4>
              <ul className="space-y-3 text-white/40">
                <li><a href="#" className="hover:text-primary transition-colors">About</a></li>
                <li><a href="#" className="hover:text-primary transition-colors">Blog</a></li>
                <li><a href="#" className="hover:text-primary transition-colors">Careers</a></li>
                <li><a href="#" className="hover:text-primary transition-colors">Contact</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold mb-4 text-white">Contact</h4>
              <ul className="space-y-3 text-white/40">
                <li className="flex items-center gap-2">
                  <Mail className="w-4 h-4" />
                  <span>hello@qcard.me</span>
                </li>
                <li className="flex items-center gap-2">
                  <Phone className="w-4 h-4" />
                  <span>+1 (555) 123-4567</span>
                </li>
                <li className="flex items-start gap-2">
                  <MapPin className="w-4 h-4 mt-0.5" />
                  <span>San Francisco, CA</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom */}
          <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/30 text-sm">
              © 2024 QCard. All rights reserved.
            </p>
            <div className="flex gap-6 text-white/30 text-sm">
              <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
              <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
              <a href="#" className="hover:text-white transition-colors">Cookie Policy</a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default FooterV2;
